var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrap-evidencia", attrs: { show: _vm.show } },
    [
      _c("div", { staticClass: "modalEnvio", attrs: { id: "myModal2" } }, [
        _c("div", { staticClass: "modalEnvio-content" }, [
          _c(
            "div",
            [
              _vm._m(0),
              _c(
                "div",
                {
                  staticClass: "buttonClose buttonCloseEvidencia",
                  attrs: { align: "right" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", small: "", color: "primary" },
                      on: { click: _vm.handleCloseReport }
                    },
                    [
                      _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                        _vm._v("close")
                      ]),
                      _vm._v("  \n            "),
                      _c("span", { staticClass: "importExportBtnTexto" }, [
                        _vm._v("Cerrar")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                _c(
                  "div",
                  { staticClass: "flex xs6 sm6 md6" },
                  [
                    _c("v-text-field", {
                      attrs: {
                        xs3: "",
                        sm3: "",
                        md3: "",
                        label: "Seleccione Archivo para carga masiva",
                        heigh: "",
                        "error-messages": _vm.errors.collect("archivo"),
                        "data-vv-name": "archivo",
                        readonly: "readonly"
                      },
                      on: {
                        click: function($event) {
                          return _vm.$refs.image.click()
                        }
                      },
                      model: {
                        value: _vm.fileName,
                        callback: function($$v) {
                          _vm.fileName = $$v
                        },
                        expression: "fileName"
                      }
                    }),
                    _c("input", {
                      ref: "image",
                      staticStyle: { display: "none" },
                      attrs: {
                        type: "file",
                        accept: ".xlsx, .xls",
                        clearable: "",
                        id: "archivoExcel"
                      },
                      on: { change: _vm.prepare_file_upload }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "flex xs2 sm2 md2" },
                  [
                    _c(
                      "v-btn",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.fileName,
                            expression: "fileName"
                          }
                        ],
                        staticStyle: { "margin-top": "10px" },
                        on: { click: _vm.quitarRegistro }
                      },
                      [_vm._v("✖")]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "flex xs2 sm2 md2" },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass:
                          "btn-sucursal btn-cargar v-btn theme--light",
                        staticStyle: { "margin-top": "10px" },
                        attrs: { disabled: _vm.errorArchivo },
                        on: { click: _vm.cargar }
                      },
                      [
                        _c("v-icon", [_vm._v("attach_file")]),
                        _vm._v("Cargar\n            ")
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ])
      ]),
      _c(
        "div",
        { staticClass: "text-xs-center" },
        [
          _c(
            "v-dialog",
            {
              attrs: { width: "500" },
              model: {
                value: _vm.errorArchivoModal,
                callback: function($$v) {
                  _vm.errorArchivoModal = $$v
                },
                expression: "errorArchivoModal"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass: "headline lighten-2",
                      attrs: { "primary-title": "" }
                    },
                    [_vm._v("Error al leer el archivo")]
                  ),
                  _c("v-card-text", {
                    domProps: { innerHTML: _vm._s(_vm.errorMessage) }
                  }),
                  _c("v-divider"),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary", flat: "" },
                          on: { click: _vm.quitarRegistro }
                        },
                        [_vm._v("Cerrar")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleEvidencia" }, [
      _c("h2", { staticClass: "importExportBtnIcon" }, [
        _vm._v("\n            Actualización Masiva Bajas Cobranza\n          ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }